/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MoneyCurrencyRubleIcon20Solid = forwardRef('MoneyCurrencyRubleIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.5 11.15H8.15v1.7H12a1.15 1.15 0 0 1 0 2.3H8.15V17a1.15 1.15 0 0 1-2.3 0v-1.85H5a1.15 1.15 0 0 1 0-2.3h.85v-1.7H5a1.15 1.15 0 0 1 0-2.3h.85V3.5c0-.911.739-1.65 1.65-1.65h5a4.65 4.65 0 0 1 0 9.3Zm-4.35-2.3v-4.7h4.35a2.35 2.35 0 1 1 0 4.7H8.15Z" })));
});
